import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { titers: Object }

  connect() {
    this.initializeTiters()
  }

  initializeTiters() {
    // Clear existing rows
    this.containerTarget.innerHTML = ""
    
    if (this.titersValue && Object.keys(this.titersValue).length > 0) {
      // Add existing titers
      Object.entries(this.titersValue).forEach(([code, titer], index) => {
        this.addRow(code, titer, index)
      })
    } else {
      // Add one empty row
      this.addRow()
    }
  }

  add(event) {
    event.preventDefault()
    this.addRow()
  }

  addRow(code = "", titer = "", index = null) {
    const actualIndex = index !== null ? index : this.containerTarget.children.length
    const row = document.createElement('div')
    row.className = 'flex items-center space-x-3'
    row.setAttribute('data-index', actualIndex)
    row.setAttribute('data-controller', 'removable-row')
    row.innerHTML = `
      <input type="text" name="expected_hi_titers_codes[]" value="${code}" placeholder="Antisera Code (e.g. AS-001)" class="flex-1 rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" />
      <input type="number" name="expected_hi_titers_values[]" value="${titer}" placeholder="Titer (e.g. 320)" class="w-32 rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" />
      <button type="button" data-action="click->removable-row#remove" class="text-red-600 hover:text-red-800 text-sm font-medium">Remove</button>
    `
    this.containerTarget.appendChild(row)
  }
}
